import useAppClientMutation, {
  AppClient,
} from "@/api/mutation/useAppClientMutation";
import ErrorMessage from "@/components/common/ErrorMessage";
import InputText from "@/components/common/InputText";
import Table, { ColumeDef } from "@/components/shared/Table";
import { Button } from "@/components/ui/button";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import { errorConfig } from "@/lib/toastError";
import { createAppClinteSchema } from "@backend/src/schemas/appClinteSchema";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { z } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";
import GreenChackMark from "@/assets/svg/GreenChackMark.svg";
import TrashCan from "@/assets/svg/TrashCan.svg";
import crossNew from "@/assets/svg/CrossIcon.svg";
import useAllTokensQuery from "@/api/query/useAllTokenQuary";
import useRemoveClientMutation from "@/api/mutation/useRemoveClinteMutaion";
import Dialog from "@/components/common/Dialog";
import Loader from "@/components/common/Loader";
import { useNavigate } from "react-router-dom";
import { useUser } from "@/hooks/useUser";
import { PlanTypeEnumSchema, UserRoleEnumValue } from "@backend/src/schemas/enums";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { baseURL } from "@/Environment";
export default function AppClint() {
  const [clientSecret, setClientSecret] = useState<AppClient[]>([]);
  const [removeToken, setRemove] = useState("");
  const [copied, setCopied] = useState({
    copy: false,
    id: "",
  });
  const { t } = useTranslation();
  const copyToClipboardWithMessage = (text: string, setShowMessage: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied({ copy: true, id: setShowMessage });
      setTimeout(() => {
        setCopied({ copy: false, id: "" });
      }, 1500); // Hide after 1.5 seconds
    });
  };

  const columnDef: ColumeDef[] | undefined = [
    {
      header: t("Client Name"),
      key: "clientName",
      onCellRender: (data: AppClient) => {
        if (data.clientName) {
          return <>{data.clientName}</>;
        } else {
          return (
            <div className="flex gap-1 items-center">
              <div>
                <InputText
                  autoFocus={true}
                  onChange={formik.handleChange}
                  name="clientName"
                  className="m-0 border-2 border-gray-300"
                  onKeyDown={(e) => {
                    if (e.key == "Enter") {
                      formik.submitForm();
                    }
                  }}
                />
                {formik.errors.clientName && (
                  <ErrorMessage>{formik.errors.clientName}</ErrorMessage>
                )}
              </div>
              <div className="flex gap1">
                <Button
                  className="p-0 mx-2"
                  variant={"none"}
                  onClick={formik.submitForm}
                >
                  <img src={GreenChackMark} className="w-4 min-w-4" />
                </Button>
                <Button
                  className="p-0 mx-2"
                  variant={"none"}
                  onClick={() => {
                    setClientSecret(clientSecret.filter((t) => t.clientName));
                  }}
                >
                  <img
                    src={crossNew}
                    className="w-2.5 min-w-2.5 brightness-0"
                  />
                </Button>
              </div>
            </div>
          );
        }
      },
    },
    {
      header: t("Client Id"),
      key: "clientOrganizationId",
      onCellRender: (data: AppClient & { index: number }) => {
        return (
          <>
            {data.clientName && (
              <div className="w-full ">
                <div className="relative">
                  <label htmlFor="npm-install-copy-button" className="sr-only">
                    {data.organisationId}
                  </label>
                  <input
                    id="npm-install-copy-button"
                    type="password"
                    className="col-span-6 bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    value={data.organisationId}
                    disabled
                    readOnly
                  />

                  {copied.copy == true &&
                    copied.id ==
                    `${data.appClientId} ${data.organisationId} ${data.index}` ? (
                    <div
                      role="tooltip"
                      className="absolute end-2 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-800 rounded-lg p-2 inline-flex items-center justify-center"
                    >
                      <span id="success-tooltip-message" className="">
                        {t("Copied!")}
                      </span>
                      <div className="tooltip-arrow" data-popper-arrow></div>
                    </div>
                  ) : (
                    <button
                      onClick={() =>
                        copyToClipboardWithMessage(
                          data.organisationId,
                          `${data.appClientId} ${data.organisationId} ${data.index}`
                        )
                      }
                      className="absolute end-2 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-800 rounded-lg p-2 inline-flex items-center justify-center"
                    >
                      <span id="default-icon">
                        <svg
                          className="w-3.5 h-3.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 18 20"
                        >
                          <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z" />
                        </svg>
                      </span>
                      <span id="success-icon" className="hidden">
                        <svg
                          className="w-3.5 h-3.5 text-blue-700 dark:text-blue-500"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 16 12"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 5.917 5.724 10.5 15 1.5"
                          />
                        </svg>
                      </span>
                    </button>
                  )}
                </div>
              </div>
            )}
          </>
        );
      },
    },
    {
      header: t("Client secret"),
      key: "clientSecret",
      onCellRender: (data: AppClient & { index: number }) => {
        return (
          <>
            {data.clientName && (
              <div className="w-full">
                <div className="relative">
                  <label htmlFor="npm-install-copy-button" className="sr-only">
                    {data.clientSecret}
                  </label>
                  <input
                    id="npm-install-copy-button"
                    type="password"
                    className="col-span-6 bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    value={data.clientSecret}
                    disabled
                    readOnly
                  />
                  {copied.copy == true &&
                    copied.id ==
                    `${data.appClientId} ${data.clientSecret} ${data.index}` ? (
                    <div
                      role="tooltip"
                      className="absolute end-2 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-800 rounded-lg p-2 inline-flex items-center justify-center"
                    >
                      <span id="success-tooltip-message" className="">
                        {t("Copied!")}
                      </span>
                      <div className="tooltip-arrow" data-popper-arrow></div>
                    </div>
                  ) : (
                    <button
                      onClick={() =>
                        copyToClipboardWithMessage(
                          data.clientSecret,
                          `${data.appClientId} ${data.clientSecret} ${data.index}`
                        )
                      }
                      className="absolute end-2 top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-800 rounded-lg p-2 inline-flex items-center justify-center"
                    >
                      <span id="default-icon">
                        <svg
                          className="w-3.5 h-3.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 18 20"
                        >
                          <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z" />
                        </svg>
                      </span>
                      <span id="success-icon" className="hidden">
                        <svg
                          className="w-3.5 h-3.5 text-blue-700 dark:text-blue-500"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 16 12"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 5.917 5.724 10.5 15 1.5"
                          />
                        </svg>
                      </span>
                    </button>
                  )}
                </div>
              </div>
            )}
          </>
        );
      },
    },
    {
      header: t("Action"),
      key: "clientName",
      onCellRender: (data: AppClient) => {
        return (
          <>
            {data.clientName && (
              <Button variant={"none"}>
                <img
                  src={TrashCan}
                  className="w-4 min-w-4 cursor-pointer"
                  onClick={() => {
                    setRemove(data.appClientId);
                  }}
                />
              </Button>
            )}
          </>
        );
      },
    },
  ];
  const removeClientMutation = useRemoveClientMutation();
  const remove = () => {
    removeClientMutation.mutate(removeToken, {
      onSuccess(data) {
        toast.success(data.data.message);
        setRemove("");
        allTokensQuery.refetch();
      },
      onError(error) {
        toast.error(
          errorKeyFormate(error.response?.data.message + ""),
          errorConfig
        );
      },
    });
  };
  const appClientMutation = useAppClientMutation();
  const formik = useFormik<z.infer<typeof createAppClinteSchema>>({
    initialValues: {
      clientName: "",
    },
    validationSchema: toFormikValidationSchema(createAppClinteSchema),
    onSubmit: (value) => {
      appClientMutation.mutate(value, {
        onSuccess(data) {
          toast.success(data.data.message);
          allTokensQuery.refetch();
        },
        onError(error) {
          toast.error(
            errorKeyFormate(error.response?.data.message + ""),
            errorConfig
          );
        },
      });
    },
  });
  const create = () => {
    const lastEntry = clientSecret[clientSecret.length - 1];

    if (clientSecret.length === 0 || (lastEntry && lastEntry.clientName)) {
      setClientSecret([
        ...clientSecret,
        {
          clientName: "",
          clientSecret: "",
          appClientId: "",
          organisationId: "",
        },
      ]);
    }
  };
  const allTokensQuery = useAllTokensQuery();
  useEffect(() => {
    setClientSecret(allTokensQuery.data?.data.data ?? []);
  }, [allTokensQuery.data?.data.data]);
  const { user } = useUser()
  const navigate = useNavigate()
  const allowToCreate = () => {
    const planType = user?.subscription?.planType
    if (planType == PlanTypeEnumSchema.ENTERPRISE) {
      if (user?.userOrganisation[0]?.role && user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR) {
        return <Button variant={"primary"} onClick={create}>
          {t("Create token")}
        </Button>
      } else {
        return <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div>
              <Button variant={"primary"} disabled>
                {t("Create token")}
              </Button>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-sm"> {t("Please ask your organisation admin to create a token")}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      }
    } else {
      return (<Button variant={"primary"} onClick={() => {
        navigate("/plans")
      }}>
        {t("Create token")}
      </Button>)
    }
  }
  return (
    <div className="mt-3">
      <hr className="my-10" />
      {allTokensQuery.isFetching ||
        allTokensQuery.isRefetching ||
        (appClientMutation.isPending && (
          <Loader className="absolute top-0 left-0 w-full h-full" />
        ))}
      <div className="w-full text-center">
        <div className="text-2xl font-bold mb-2">{t("App Client")}</div>
        <div className="text-base">{t("App subtitle")}</div>
      </div>
      <div className="flex gap-2 items-center justify-end my-2">
        <div className="flex gap-2 items-center">
          <a target="_blank" href={baseURL +"/docs#authentication"} className="text-primary-500 underline">{t("Documentation")}</a>
          {allowToCreate()}
        </div>
      </div>
      <Table
        className="!px-0"
        data={clientSecret}
        columnDef={columnDef}
      ></Table>
      <Dialog
        isOpen={Boolean(removeToken)}
        onClose={() => { }}
        modalClass="rounded-lg"
      >
        <div className="flex flex-col gap-2 p-6 ">
          <img src={TrashCan} className="w-12 m-auto" />{" "}
          {t("common_delete_message")}
          <div className="flex gap-2 ml-auto">
            <Button
              variant={"outline"}
              isLoading={removeClientMutation.isPending}
              disabled={removeClientMutation.isPending}
              onClick={() => setRemove("")}
            >
              {t("cancel")}
            </Button>
            <Button variant={"primary"} onClick={remove}>
              {t("delete")}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
